import React from "react"
import { createRoot } from "react-dom/client"
import { RevealRoot } from "./reveal"
import { GalleryRoot } from "./gallery"

const roots = new Map()

export function mountIslands() {
  document.querySelectorAll("[data-react-root]").forEach((node) => {
    if (roots.has(node)) return
    const root = createRoot(node)
    roots.set(node, root)
    if (node.getAttribute("data-react-root") === "gallery") {
      root.render(React.createElement(GalleryRoot))
    }
  })
  RevealRoot.observe(document)
}

export function unmountIslands() {
  RevealRoot.disconnect()
  roots.forEach((root) => root.unmount())
  roots.clear()
}
